module.exports = __webpack_public_path__ + "static/img/banner.f1af9f96.png";